// ============================================================================
// Does a column exist on the live database?
// ----------------------------------------------------------------------------
// Migrations on this project are applied by hand (backend/*.sql), so a page
// can ship before its column does. Writing to a column PostgREST does not
// know fails the WHOLE insert ("Could not find the 'x' column … in the schema
// cache"), which would break saving a payment because of an optional box.
//
// So a page asks once, hides the box while the answer is "no", and starts
// storing the value the moment the migration lands — no redeploy needed.
// The probe is one cheap SELECT of that column with LIMIT 0; a missing column
// comes back as a 42703 / PGRST204 error, anything else counts as present.
// ============================================================================
import { supabase } from './supabase';

const cache = new Map();

/**
 * @param {string} table
 * @param {string} column
 * @returns {Promise<boolean>}
 */
export function hasColumn(table, column) {
  const key = `${table}.${column}`;
  if (!cache.has(key)) {
    cache.set(key, supabase
      .from(table)
      .select(column)
      .limit(0)
      .then(({ error }) => {
        if (!error) return true;
        const code = String(error.code || '');
        const msg = String(error.message || '');
        // Unknown column: the migration is not applied yet.
        if (code === '42703' || code === 'PGRST204' || /column .* does not exist|schema cache/i.test(msg)) return false;
        // Any other failure (network, RLS…) must not hide a working box.
        return true;
      })
      .catch(() => true));
  }
  return cache.get(key);
}

/** Test hook: forget every cached answer. */
export function _resetSchemaProbe() {
  cache.clear();
}
